// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Location: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12">
            <path
                fill="currentColor"
                d="M4.125,0 C1.84701174,0 0,1.84701174 0,4.125 C0,5.78810555 0.57943362,6.25259763 3.70175788,10.7787112 C3.90652558,11.0745515 4.34435561,11.0745515 4.54910168,10.7787112 C7.66992188,6.25195312 8.25,5.78789049 8.25,4.125 C8.25,1.84701174 6.40234375,0 4.125,0 Z M4.125,5.82441419 C3.17689443,5.82441419 2.40625,5.05355471 2.40625,4.10566419 C2.40625,3.15777367 3.17753893,2.38691419 4.125,2.38691419 C5.07246107,2.38691419 5.84375,3.15777302 5.84375,4.10566419 C5.84375,5.05355504 5.07246107,5.82441419 4.125,5.82441419 Z"
                transform="translate(0 .375)"
            />
        </svg>
    );
};

export default React.memo(Location);
